import { render, staticRenderFns } from "./permissions.vue?vue&type=template&id=9e3202c2&scoped=true&"
import script from "./permissions.vue?vue&type=script&lang=js&"
export * from "./permissions.vue?vue&type=script&lang=js&"
import style0 from "./permissions.vue?vue&type=style&index=0&id=9e3202c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e3202c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e3202c2')) {
      api.createRecord('9e3202c2', component.options)
    } else {
      api.reload('9e3202c2', component.options)
    }
    module.hot.accept("./permissions.vue?vue&type=template&id=9e3202c2&scoped=true&", function () {
      api.rerender('9e3202c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/form-fields/permissions.vue"
export default component.exports